const getSuburbName = (
  suburbName?: string | null,
  destinationName?: string | null,
): string => {
  const suburbTrimmed =
    suburbName
      ?.replace(/[\d,]/g, '') // Remove numbers and commas
      .replace(/\s+/g, ' ') // Collapse consecutive spaces into one
      .trim() ?? '';

  const destinationTrimmed = destinationName?.trim() ?? '';

  if (!suburbTrimmed) {
    return destinationTrimmed;
  }

  if (!destinationTrimmed) {
    return suburbTrimmed;
  }

  return destinationTrimmed.toLowerCase().includes(suburbTrimmed.toLowerCase())
    ? destinationTrimmed
    : `${suburbTrimmed}, ${destinationTrimmed}`;
};

export default getSuburbName;
